import React, { useEffect, useId, useRef, useState } from 'react';
import { X, Wallet, CheckCircle2, AlertCircle, TrendingUp, Maximize2 } from 'lucide-react';
import ContaReceberDetalhe from './ContaReceberDetalhe';

// Subcomponente interno com suporte opcional ao botão de expansão
function ModalStatBox({ title, icon: Icon, color, border, value, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} p-4 sm:p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* O botão só aparece se a função onExpand for fornecida */}
      {onExpand && (
        <button
          onClick={onExpand}
          aria-label={`Ver detalhes de ${title}`}
          className="absolute top-1 right-1 flex h-11 w-11 items-center justify-center rounded text-gray-400 hover:text-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-colors z-20"
        >
          <Maximize2 size={18} />
        </button>
      )}

      <div className={`flex items-center gap-2 mb-4 pr-10 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>
      <div>
        <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Valor Total</p>
        <p className={`font-mono text-xl sm:text-2xl break-words font-bold italic tracking-tighter ${color === 'text-yellow-500' ? 'text-white' : color}`}>
          {value}
        </p>
      </div>
    </div>
  );
}

export default function ContaReceberTotal({ data, onClose }) {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const titleId = useId();
  const closeRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus?.();
    };
  }, []);

  useEffect(() => {
    const handleEscape = event => {
      if (event.key === 'Escape' && !isDetailOpen) onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose, isDetailOpen]);

  const handleDialogKeyDown = event => {
    if (event.key !== 'Tab' || isDetailOpen) return;
    const buttons = dialogRef.current.querySelectorAll('button:not([disabled])');
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };

  const formatBRL = (val) =>
    Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const desconto = data?.desconto || 0;
  const acrescimo = data?.acrescimo || 0;

  const aReceber = data?.recebidoMes || 0;
  const recebido = data?.valorRecebidoMes  || 0;

  const saldoEmAberto = data?.aReceberMes  || 0;
  const percentual = recebido > 0 ?  ((((recebido)/ aReceber) * 100).toFixed(2)) : 0;  


  return (
    <>
      <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-2 sm:p-4">
        <div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby={titleId} onKeyDown={handleDialogKeyDown} className="flex max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] min-h-0 flex-col bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">

          {/* Cabeçalho */}
          <div className="flex shrink-0 justify-between items-center gap-3 p-3 sm:p-4 border-b border-gray-800 bg-[#161b22]">
            <div className="flex min-w-0 items-center gap-2 text-yellow-500 font-bold tracking-wide sm:tracking-widest text-[10px] sm:text-xs uppercase">
              <Wallet size={18} className="shrink-0" />
              <h2 id={titleId} className="min-w-0 break-words">Detalhamento Financeiro Recebimento (Mês)</h2>
            </div>
            <button ref={closeRef} onClick={onClose} aria-label="Fechar resumo de recebimentos" className="flex h-11 w-11 shrink-0 items-center justify-center rounded border border-gray-700 text-gray-200 hover:bg-gray-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-colors">
              <X size={20} />
            </button>
          </div>

          {/* Conteúdo */}
          <div className="min-h-0 overflow-y-auto overscroll-contain p-3 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
            {/* Adicionado o onExpand especificamente neste card */}
            <ModalStatBox
              title="Total a Receber"
              icon={Wallet}
              color="text-yellow-500"
              border="border-yellow-500"
              value={formatBRL(aReceber)}
              onExpand={() => setIsDetailOpen(true)}
            />
            <ModalStatBox
              title="Total Recebido"
              icon={CheckCircle2}
              color="text-green-400"
              border="border-green-500"
              value={formatBRL(recebido)}
            //  onExpand={() => setIsDetailOpen(true)}
            />
             <ModalStatBox
              title="Total Desconto"
              icon={AlertCircle}
              color="text-red-400"
              border="border-red-500"
              value={formatBRL(desconto)}
              //onExpand={() => setIsDetailOpen(true)}
            />
            <ModalStatBox
              title="Total Acréscimo"
              icon={CheckCircle2}
              color="text-green-400"
              border="border-green-500"
              value={formatBRL(acrescimo)}
             // onExpand={() => setIsDetailOpen(true)}
            />            
            <ModalStatBox
              title="Saldo em Aberto"
              icon={AlertCircle}
              color="text-red-400"
              border="border-red-500"
              value={formatBRL(saldoEmAberto)}
             // onExpand={() => setIsDetailOpen(true)}
            /> 
            
            {/* Card de Eficiência */}
            <div className="bg-[#161b22] border-l-4 border-blue-500 p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]">
              <div className="flex items-center gap-2 mb-4 text-blue-400 font-black text-[10px] uppercase tracking-widest">
                <TrendingUp size={14} /> <span>Eficiência de Recebimento</span>
              </div>
              <div className="flex items-end gap-4">
                <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">{percentual}%</p>
                <div className="flex-1 bg-gray-900 h-2 rounded-full mb-2 overflow-hidden">
                  <div
                    className="bg-green-500 h-full shadow-[0_0_8px_#22c55e]"
                    style={{ width: `${percentual}%` }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Rodapé */}
          <div className="shrink-0 p-3 sm:p-4 bg-[#0d1117] text-right border-t border-gray-800">
            <button
              onClick={onClose}
              className="min-h-11 w-full sm:w-auto bg-gray-800 hover:bg-gray-700 text-white text-xs font-black py-3 px-8 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-all uppercase tracking-widest shadow-lg"
            >
              Fechar Janela
            </button>
          </div>
        </div>
      </div>
      
      {isDetailOpen && (
        <ContaReceberDetalhe
          data={data}
          onClose={() => setIsDetailOpen(false)}
        />
      )}
    </>
  );
}